import React from "react";
import "./index.css";
import { LockOutlined } from "@ant-design/icons";

const FeatureCard = ({ number, badge, icon, title, description }) => {
  return (
    <div className="feature-card">
      {/* Icon always leads the row so the purple tiles line up across every card */}
      <div className="feature-card-top">
        <span className="feature-card-icon">{icon}</span>
        <div className="feature-card-meta">
          {badge && (
            <span className="feature-card-badge">
              <LockOutlined /> {badge}
            </span>
          )}
          <span className="feature-card-number">{number}</span>
        </div>
      </div>
      <h3 className="feature-card-title">{title}</h3>
      <p className="feature-card-description">{description}</p>
    </div>
  );
};

export default FeatureCard;
